var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 147,
    viewBox: "0 0 147 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 73.5,
    cy: 73.5,
    r: 73.5,
    fill: "#E3F444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.793 45.1719H41.207C37.2251 45.1719 34 48.417 34 52.3789V95.6211C34 99.6066 37.2488 102.828 41.207 102.828H108.793C112.742 102.828 116 99.6202 116 95.6211V52.3789C116 48.424 112.788 45.1719 108.793 45.1719ZM107.784 49.9766L80.0962 77.5182C78.7348 78.8795 76.9251 79.629 75 79.629C73.0749 79.629 71.2652 78.8793 69.8993 77.5137L42.2163 49.9766H107.784ZM38.8047 94.6432V53.3599L59.567 74.0128L38.8047 94.6432ZM42.2194 98.0234L62.9735 77.4012L66.5064 80.9155C68.7752 83.1843 71.7916 84.4337 75 84.4337C78.2084 84.4337 81.2248 83.1843 83.4891 80.92L87.0265 77.4012L107.781 98.0234H42.2194ZM111.195 94.6432L90.433 74.0128L111.195 53.3599V94.6432Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.35d4bd4196ae7a1ccdc4a6c44d69721a.svg";
export { ForwardRef as ReactComponent };